import { render, staticRenderFns } from "./recurrencesRegle.vue?vue&type=template&id=36dafcc0&"
import script from "./recurrencesRegle.vue?vue&type=script&lang=ts&"
export * from "./recurrencesRegle.vue?vue&type=script&lang=ts&"
import style0 from "./recurrencesRegle.vue?vue&type=style&index=0&id=36dafcc0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports